import React, {createContext, useContext, useState} from 'react';

const QnaContext = createContext({page: 0, size: 10, searchWrd: '', isAnswered: ''});

const QnaProvider = ({children}) => {
    const [options, setOptions] = useState({page: 0, size: 10, searchWrd: '', isAnswered: ''});

    const value = {
        options,
        setOptions,
    };

    return (
        <QnaContext.Provider value={value}>
            {children}
        </QnaContext.Provider>
    );
};

const useQnaContext = () => {
    return useContext(QnaContext);
};

export {QnaProvider, useQnaContext};
